import { Injectable } from '@angular/core';
import {
  get,
  post,
  put,
  patch,
  del,
  generateClient,
  Client,
} from 'aws-amplify/api';
import { ErrorUtil } from './error.util';

@Injectable({
  providedIn: 'root',
})
export class CaiApi {
  static client: Client = generateClient();

  static async get<T>(apiName, path, options): Promise<T> {
    try {
      const request = get({ apiName, path, options });
      const { body } = await request.response;
      const responseText = await body.text();
      if (responseText) {
        return JSON.parse(responseText);
      }
      return null;
    } catch (e) {
      if (!e?.response?.config) {
        e.config = {};
        e.config.method = 'GET';
        e.config.url = path;
      }
      return ErrorUtil.handleError(e);
    }
  }

  static async getText(apiName, path, options): Promise<string> {
    try {
      const request = get({ apiName, path, options });
      const { body } = await request.response;
      return body.text();
    } catch (e) {
      if (!e?.response?.config) {
        e.config = {};
        e.config.method = 'GET';
        e.config.url = path;
      }
      return ErrorUtil.handleError(e);
    }
  }

  static async post<T>(apiName, path, options): Promise<T> {
    try {
      options.retryStrategy = {
        strategy: 'no-retry', // Overrides default retry strategy
      };
      const request = post({ apiName, path, options });
      const { body } = await request.response;
      const responseText = await body.text();
      if (responseText) {
        return JSON.parse(responseText);
      }
      return null;
    } catch (e) {
      if (!e?.response?.config) {
        e.config = {};
        e.config.method = 'POST';
        e.config.url = path;
      }
      return ErrorUtil.handleError(e);
    }
  }

  static async postText(apiName, path, options): Promise<string> {
    try {
      options.retryStrategy = {
        strategy: 'no-retry', // Overrides default retry strategy
      };
      const request = post({ apiName, path, options });
      const { body } = await request.response;
      return body.text();
    } catch (e) {
      if (!e?.response?.config) {
        e.config = {};
        e.config.method = 'POST';
        e.config.url = path;
      }
      return ErrorUtil.handleError(e);
    }
  }

  static async put<T>(apiName, path, options): Promise<T> {
    try {
      options.retryStrategy = {
        strategy: 'no-retry', // Overrides default retry strategy
      };
      const request = put({ apiName, path, options });
      const { body } = await request.response;
      const responseText = await body.text();
      if (responseText) {
        return JSON.parse(responseText);
      }
      return null;
    } catch (e) {
      if (!e?.response?.config) {
        e.config = {};
        e.config.method = 'PUT';
        e.config.url = path;
      }
      return ErrorUtil.handleError(e);
    }
  }

  static async patch<T>(apiName, path, options): Promise<T> {
    try {
      options.retryStrategy = {
        strategy: 'no-retry', // Overrides default retry strategy
      };
      const request = patch({ apiName, path, options });
      const { body } = await request.response;
      const responseText = await body.text();
      if (responseText) {
        return JSON.parse(responseText);
      }
      return null;
    } catch (e) {
      if (!e?.response?.config) {
        e.config = {};
        e.config.method = 'PATCH';
        e.config.url = path;
      }
      return ErrorUtil.handleError(e);
    }
  }

  static async del<T>(apiName, path, options): Promise<T> {
    try {
      const request = del({ apiName, path, options });
      const { body } = (await request.response) as any;
      const responseText = await body.text();
      if (responseText) {
        return JSON.parse(responseText);
      }
      return null;
    } catch (e) {
      if (!e?.response?.config) {
        e.config = {};
        e.config.method = 'DEL';
        e.config.url = path;
      }
      return ErrorUtil.handleError(e);
    }
  }

  static graphql<T>(options: { query; variables; authMode }): T {
    return CaiApi.client.graphql(options) as any;
  }
}
